import { Component, EventEmitter, Input, Output, signal, booleanAttribute } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './search-bar.component.html',
})
export class SearchBarComponent {
  @Input() placeholder: string = 'Enter text';
  @Input() value: string = '';
  @Input({ transform: booleanAttribute }) showSearchIcon: boolean = true;
  @Input({ transform: booleanAttribute }) loading: boolean = false;
  @Input({ transform: booleanAttribute }) clearable: boolean = false;
  @Input() buttonLabel: string = '';
  @Input() errorMessage: string | null = null;
  @Input({ transform: booleanAttribute }) disabled: boolean = false;
  @Input() className: string = '';

  @Output() valueChange = new EventEmitter<string>();
  @Output() buttonClick = new EventEmitter<MouseEvent>();
  @Output() focus = new EventEmitter<FocusEvent>();
  @Output() blur = new EventEmitter<FocusEvent>();
  @Output() searchKeydown = new EventEmitter<KeyboardEvent>();
  @Output() clear = new EventEmitter<void>();

  isFocused = signal(false);

  onInput(val: string): void {
    this.value = val;
    this.valueChange.emit(val);
  }

  onClear(event: MouseEvent): void {
    event.stopPropagation();
    this.value = '';
    this.valueChange.emit('');
    this.clear.emit();
  }

  onButtonClick(event: MouseEvent): void {
    if (this.disabled) return;
    this.buttonClick.emit(event);
  }

  onFocus(event: FocusEvent): void {
    this.isFocused.set(true);
    this.focus.emit(event);
  }

  onBlur(event: FocusEvent): void {
    this.isFocused.set(false);
    this.blur.emit(event);
  }

  onKeyDown(event: KeyboardEvent): void {
    this.searchKeydown.emit(event);
  }
}
